<template>
  <div v-if="invalid == false">
    <h3>Loading...</h3>
    <p>Verifying your link...</p>
  </div>
  <div v-else>
    <h3>Error</h3>
    <p>The link you followed is invalid or has expired. Please contact your representative for a new link.</p>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'VerifyLoading',
  components: {
  },
  props: {
    link: String
  },
  data () {
    return {
      invalid: false
    }
  },
  methods: {
    next () {
      this.$emit('next', this.$data)
      console.log(this.$data)
    },
    doubleNext () {
      this.$emit('doublenext', this.$data)
    }
  },
  mounted: function () {
    var self = this
    $.ajax({
      type: 'POST',
      url: '/api/bank-verification/verify-link',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ link: this.link })
    }).done(function (response) {
      if (response.source && response.source == 'legacy-app'){
        self.next()
      }
      else {
        self.next()
      }
      
    }).fail(function (err) {
      console.log(err.responseText)
      self.invalid = true
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
